// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from "react-redux";
// import API from '../utils/apiClient';

// const PaymentPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { totalPrice, subjectNames } = location.state || {};
//   const [paymentData, setPaymentData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const dispatch = useDispatch();
//   const { email, phoneNo, name } = useSelector((state) => ({
//     email: state.email,
//     phoneNo: state.phoneNo,
//     name: state.name,
//   }));

//   const generateOrderId = () => {
//     const timestamp = Date.now();
//     const randomPart = Math.floor(1000 + Math.random() * 9000);
//     return `ORD-${timestamp}-${randomPart}`;
//   };

//   const makePaymentRequest = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const order_id = generateOrderId();
//       dispatch({
//         type: 'ORDER_ID',
//         payload: { OrderId: order_id },
//       });

//       const result = await API.call('/payment', 'POST', {
//         token: "ba6077-f00a1c-836d77-18de63-9c9e81",
//         order_id: order_id,
//         txn_amount: totalPrice,
//         txn_note: "Pay For Scribbles",
//         product_name: Array.isArray(subjectNames) ? subjectNames.join(", ") : JSON.stringify(subjectNames),
//         customer_name: name,
//         customer_mobile: phoneNo,
//         customer_email: email,
//         redirect_url: "",
//       });

//       if (!result.success) {
//         throw new Error("Payment creation failed!");
//       }

//       const data = result.data;
//       setPaymentData(data);

//       if (data.results && data.results.length > 0) {
//         const paymentUrl = data.results[0].payment_url;

//         if (paymentUrl) {
//           window.open(paymentUrl, "_blank", "width=600,height=600");
//           pollPaymentStatus(order_id); // Start polling for payment status
//         } else {
//           setError("Payment URL not available.");
//         }
//       }
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const pollPaymentStatus = async (order_id) => {
//     const maxAttempts = 12; // Poll for 1 minute (12 attempts with a 5-second interval)
//     let attempts = 0;

//     const interval = setInterval(async () => {
//       attempts++;
//       try {
//         const result = await API.getPaymentStatus(order_id);

//         if (result.success) {
//           const data = result.data;
//           if (data.results && data.results.results.status === "Success") {
//             const productNames = data.results.results.product_name.split(', ');
//             await updateUserInfo(productNames); // Update user info with purchased products
//             clearInterval(interval); // Stop polling
//             navigate("/Courses"); // Redirect on success
//           } else if (attempts >= maxAttempts) {
//             setError("Payment verification timed out.");
//             clearInterval(interval); // Stop polling after max attempts
//           }
//         } else if (attempts >= maxAttempts) {
//           setError("Payment verification timed out.");
//           clearInterval(interval);
//         }
//       } catch (err) {
//         console.error("Error while polling payment status:", err.message);
//         clearInterval(interval);
//         setError("Error checking payment status.");
//       }
//     }, 5000);
//   };

//   const updateUserInfo = async (productNames) => {
//     try {
//       const result = await API.updateUser({
//         email: email,
//         subjects: Array.isArray(productNames) ? productNames : [productNames],
//       });

//       if (!result.success) {
//         throw new Error(`Error updating user info: ${result.error}`);
//       }

//       const data = await response.json();
//       console.log('User info updated successfully:', data);
//     } catch (error) {
//       console.error('Failed to update user info:', error.message);
//     }
//   };

//   useEffect(() => {
//     if (totalPrice && subjectNames) {
//       makePaymentRequest();
//     }
//   }, [totalPrice, subjectNames]);

//   return (
//     <div>
//       <h2>Payment Page</h2>
//       {loading && <p>Loading... Please wait.</p>}
//       {error && <p style={{ color: 'red' }}>{error}</p>}
//       {paymentData && paymentData.results && paymentData.results.length > 0 && (
//         <div>
//           <h3>Payment Info:</h3>
//           <p>Transaction ID: {paymentData.results[0].txn_id}</p>
//           <p>Product: {paymentData.results[0].product_name}</p>
//           <p>Payment Mode: {paymentData.results[0].payment_mode}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentPage;


// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from "react-redux";
// import API from '../utils/apiClient';

// const PaymentPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { totalPrice, subjectNames } = location.state || {};
//   const [paymentData, setPaymentData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const dispatch = useDispatch();
//   const { email, phoneNo, name } = useSelector((state) => ({
//     email: state.email,
//     phoneNo: state.phoneNo,
//     name: state.name,
//   }));

//   const generateOrderId = () => {
//     const timestamp = Date.now();
//     const randomPart = Math.floor(1000 + Math.random() * 9000);
//     return `ORD-${timestamp}-${randomPart}`;
//   };

//   const makePaymentRequest = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const order_id = generateOrderId();
//       dispatch({
//         type: 'ORDER_ID',
//         payload: { OrderId: order_id },
//       });

//       const paymentPayload = {
//         token: "ba6077-f00a1c-836d77-18de63-9c9e81",
//         order_id: order_id,
//         txn_amount: totalPrice,
//         txn_note: "Pay For Scribbles",
//         product_name: Array.isArray(subjectNames) ? subjectNames.join(", ") : JSON.stringify(subjectNames),
//         customer_name: name,
//         customer_mobile: phoneNo,
//         customer_email: email,
//         redirect_url: "",
//       };

//       console.log('Sending payment request:', paymentPayload);

//       const result = await API.call('/payment', 'POST', paymentPayload);

//       console.log('Payment API Response:', result);

//       if (!result.success) {
//         const errorMessage = result.error || result.message || "Payment creation failed!";
//         console.error('Payment failed:', errorMessage, result);
//         throw new Error(errorMessage);
//       }

//       const data = result.data;
//       setPaymentData(data);

//       console.log('Payment data structure:', JSON.stringify(data, null, 2));

//       // Check multiple possible response structures (both snake_case and camelCase)
//       let paymentUrl = null;
      
//       if (data.results && Array.isArray(data.results) && data.results.length > 0) {
//         // Try both snake_case and camelCase
//         paymentUrl = data.results[0].paymentUrl || data.results[0].payment_url;
//       } else if (data.paymentUrl || data.payment_url) {
//         paymentUrl = data.paymentUrl || data.payment_url;
//       }

//       if (paymentUrl) {
//         console.log('Opening payment URL:', paymentUrl);
//         window.open(paymentUrl, "_blank", "width=600,height=600");
//         pollPaymentStatus(order_id);
//       } else {
//         console.error('Cannot find payment_url in response:', data);
//         setError("Payment URL not available in response. Check console for details.");
//       }
//     } catch (err) {
//       console.error('Payment error:', err);
//       setError(err.message || "An error occurred during payment");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const pollPaymentStatus = async (order_id) => {
//     const maxAttempts = 12;
//     let attempts = 0;

//     const interval = setInterval(async () => {
//       attempts++;
//       try {
//         const result = await API.getPaymentStatus(order_id);

//         if (result.success) {
//           const data = result.data;
//           if (data.results && data.results.results && data.results.results.status === "Success") {
//             const productNames = data.results.results.product_name.split(', ');
//             await updateUserInfo(productNames);
//             clearInterval(interval);
//             navigate("/Courses");
//           } else if (attempts >= maxAttempts) {
//             setError("Payment verification timed out.");
//             clearInterval(interval);
//           }
//         } else if (attempts >= maxAttempts) {
//           setError("Payment verification timed out.");
//           clearInterval(interval);
//         }
//       } catch (err) {
//         console.error("Error while polling payment status:", err.message);
//         clearInterval(interval);
//         setError("Error checking payment status.");
//       }
//     }, 5000);
//   };

//   const updateUserInfo = async (productNames) => {
//     try {
//       const result = await API.updateUser({
//         email: email,
//         subjects: Array.isArray(productNames) ? productNames : [productNames],
//       });

//       if (!result.success) {
//         throw new Error(`Error updating user info: ${result.error}`);
//       }

//       console.log('User info updated successfully:', result.data);
//     } catch (error) {
//       console.error('Failed to update user info:', error.message);
//     }
//   };

//   useEffect(() => {
//     if (totalPrice && subjectNames) {
//       makePaymentRequest();
//     } else {
//       setError("Missing payment information. Please go back and try again.");
//       setLoading(false);
//     }
//   }, []);

//   return (
//     <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
//       <h2>Payment Page</h2>
//       {loading && <p>Processing payment... Please wait.</p>}
//       {error && (
//         <div style={{ 
//           color: 'red', 
//           padding: '10px', 
//           border: '1px solid red', 
//           borderRadius: '5px',
//           marginTop: '10px'
//         }}>
//           <strong>Error:</strong> {error}
//         </div>
//       )}
//       {paymentData && paymentData.results && paymentData.results.length > 0 && (
//         <div style={{ 
//           marginTop: '20px', 
//           padding: '15px', 
//           border: '1px solid #ddd',
//           borderRadius: '5px' 
//         }}>
//           <h3>Payment Info:</h3>
//           <p><strong>Transaction ID:</strong> {paymentData.results[0].txn_id}</p>
//           <p><strong>Product:</strong> {paymentData.results[0].product_name}</p>
//           <p><strong>Payment Mode:</strong> {paymentData.results[0].payment_mode}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentPage;


import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import API from '../utils/apiClient';

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { totalPrice, subjectNames } = location.state || {};
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const { email, phoneNo, name } = useSelector((state) => ({
    email: state.email,
    phoneNo: state.phoneNo,
    name: state.name,
  }));

  const generateOrderId = () => {
    const timestamp = Date.now();
    const randomPart = Math.floor(1000 + Math.random() * 9000);
    return `ORD-${timestamp}-${randomPart}`;
  };

  const makePaymentRequest = async () => {
    setLoading(true);
    setError(null);

    try {
      const order_id = generateOrderId();
      dispatch({
        type: 'ORDER_ID',
        payload: { OrderId: order_id },
      });

      const paymentPayload = {
        token: "ba6077-f00a1c-836d77-18de63-9c9e81",
        order_id: order_id,
        txn_amount: totalPrice,
        txn_note: "Pay For Scribbles",
        product_name: Array.isArray(subjectNames) ? subjectNames.join(", ") : JSON.stringify(subjectNames),
        customer_name: name,
        customer_mobile: phoneNo,
        customer_email: email,
        redirect_url: "",
      };

      console.log('Sending payment request:', paymentPayload);

      const result = await API.call('/payment', 'POST', paymentPayload);

      console.log('Payment API Response:', result);

      if (!result.success) {
        const errorMessage = result.error || result.message || "Payment creation failed!";
        console.error('Payment failed:', errorMessage, result);
        throw new Error(errorMessage);
      }

      const data = result.data;
      setPaymentData(data);

      console.log('Payment data structure:', JSON.stringify(data, null, 2));

      // Check response structure - results is now a single object, not an array
      let paymentUrl = null;
      
      if (data.results) {
        // results is now an object, not an array
        paymentUrl = data.results.paymentUrl || data.results.payment_url;
      } else if (data.paymentUrl || data.payment_url) {
        paymentUrl = data.paymentUrl || data.payment_url;
      }

      if (paymentUrl) {
        console.log('Opening payment URL:', paymentUrl);
        window.open(paymentUrl, "_blank", "width=600,height=600");
        pollPaymentStatus(order_id);
      } else {
        console.error('Cannot find payment_url in response:', data);
        setError("Payment URL not available in response. Check console for details.");
      }
    } catch (err) {
      console.error('Payment error:', err);
      setError(err.message || "An error occurred during payment");
    } finally {
      setLoading(false);
    }
  };

  const pollPaymentStatus = async (order_id) => {
    const maxAttempts = 24; // Increased from 12 to give more time
    let attempts = 0;

    const interval = setInterval(async () => {
      attempts++;
      console.log(`Checking payment status... Attempt ${attempts}/${maxAttempts}`);
      
      try {
        const result = await API.getPaymentStatus(order_id);
        console.log('Payment status response:', result);

        if (result.success) {
          const data = result.data;
          console.log('Payment status data:', data);
          
          // Check for successful payment in various possible structures
          let paymentSuccess = false;
          let productNames = null;

          // Check different possible response structures
          if (data.results && data.results.results) {
            const status = data.results.results.status;
            console.log('Payment status:', status);
            
            if (status === "Success" || status === "success" || status === "COMPLETED") {
              paymentSuccess = true;
              productNames = data.results.results.product_name;
            }
          } else if (data.status === "Success" || data.status === "success") {
            paymentSuccess = true;
            productNames = data.product_name;
          } else if (data.results && data.results.status) {
            const status = data.results.status;
            if (status === "Success" || status === "success" || status === "COMPLETED") {
              paymentSuccess = true;
              productNames = data.results.product_name;
            }
          }

          if (paymentSuccess) {
            console.log('Payment successful! Product names:', productNames);
            clearInterval(interval);
            
            // Update user info with purchased subjects
            const productNamesArray = productNames ? productNames.split(', ') : subjectNames;
            await updateUserInfo(productNamesArray);
            
            // Clear the cart after successful payment
            console.log('[DEBUG] Clearing cart after successful payment');
            dispatch({
              type: 'CLEAR_CART',
            });
            
            // Also clear cart from localStorage if you're using it
            try {
              localStorage.removeItem('cart');
              localStorage.removeItem('cartItems');
              localStorage.removeItem('totalPrice');
              console.log('[DEBUG] Cart cleared from localStorage');
            } catch (err) {
              console.warn('Could not clear localStorage:', err);
            }
            
            // Show success message
            setLoading(false);
            setError(null);
            alert('Payment successful! Your cart has been cleared. Redirecting to My Learning...');
            
            // Navigate to My Learning page
            navigate("/myCourses");
          } else if (attempts >= maxAttempts) {
            console.log('Payment verification timed out');
            clearInterval(interval);
            setLoading(false);
            setError("Payment verification timed out. Please contact support if payment was deducted.");
          }
        } else if (attempts >= maxAttempts) {
          console.log('Max attempts reached');
          clearInterval(interval);
          setLoading(false);
          setError("Payment verification timed out. Please contact support if payment was deducted.");
        }
      } catch (err) {
        console.error("Error while polling payment status:", err);
        if (attempts >= maxAttempts) {
          clearInterval(interval);
          setLoading(false);
          setError("Error checking payment status. Please contact support if payment was deducted.");
        }
      }
    }, 5000); // Check every 5 seconds
  };

  const updateUserInfo = async (productNames) => {
    try {
      console.log('[DEBUG] Updating user info with products:', productNames);
      console.log('[DEBUG] User email:', email);
      
      const result = await API.updateUser({
        email: email,
        subjects: Array.isArray(productNames) ? productNames : [productNames],
      });

      console.log('[DEBUG] Update user response:', result);

      if (!result.success) {
        throw new Error(`Error updating user info: ${result.error}`);
      }

      console.log('User info updated successfully:', result.data);
    } catch (error) {
      console.error('Failed to update user info:', error.message);
      throw error;
    }
  };

  useEffect(() => {
    if (totalPrice && subjectNames) {
      makePaymentRequest();
    } else {
      setError("Missing payment information. Please go back and try again.");
      setLoading(false);
    }
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Payment Page</h2>
      {loading && <p>Processing payment... Please wait.</p>}
      {error && (
        <div style={{ 
          color: 'red', 
          padding: '10px', 
          border: '1px solid red', 
          borderRadius: '5px',
          marginTop: '10px'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      {paymentData && paymentData.results && (
        <div style={{ 
          marginTop: '20px', 
          padding: '15px', 
          border: '1px solid #ddd',
          borderRadius: '5px' 
        }}>
          <h3>Payment Info:</h3>
          <p><strong>Transaction ID:</strong> {paymentData.results.txnId}</p>
          <p><strong>Product:</strong> {paymentData.results.productName}</p>
          <p><strong>Amount:</strong> ₹{paymentData.results.txnAmount}</p>
        </div>
      )}
    </div>
  );
};

export default PaymentPage;